import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VendorService } from '../../services/vendor.service';

@Component({
	selector: 'app-vendor-payment-modal',
	templateUrl: './vendor-payment-modal.component.html',
	styleUrls: ['./vendor-payment-modal.component.scss'],
})
export class VendorPaymentModalComponent implements OnInit {
	supplierid = '';
	vendorTitle = '';
	/** Name from the calling row — used when vendor/read comes back without one. */
	vendorName = '';
	/** Full brand-payout row from the dashboard — drives summary card + amount pre-fill. */
	payoutRow: any = null;
	/** Generic (non-brand) mode: pre-fill the payment amount, e.g. the vendor's past-due total. */
	suggestedAmount: number | null = null;

	vendorData: any = null;
	loading = true;
	loadError = false;

	constructor(
		public activeModal: NgbActiveModal,
		private vendorService: VendorService,
	) {}

	ngOnInit(): void {
		const id = this.supplierid?.trim();
		if (!id) {
			this.loading = false;
			this.loadError = true;
			return;
		}

		this.vendorService.getVendor(id).subscribe({
			next: (result: any) => {
				// vendor/read never 404s: on a miss it returns a synthetic record built
				// around an empty row, with no supplierid and no suppname. Rendering on
				// that produced "Vendor Payment – undefined" and loaded no invoices,
				// because supplierid was undefined all the way down. Backfill both from
				// what the caller already knows so the pay screen still works.
				if (!result || Array.isArray(result) || !Object.keys(result).length) {
					this.loadError = true;
					this.loading = false;
					return;
				}
				this.vendorData = {
					...result,
					supplierid: result.supplierid || id,
					suppname: result.suppname || this.vendorName || id,
				};
				this.loading = false;
			},
			error: () => {
				this.loadError = true;
				this.loading = false;
			},
		});
	}

	onPaymentPosted(): void {
		this.activeModal.close('payment_posted');
	}
}
